"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequestTypes = exports.action = exports.ALL_ACTION_TYPES = exports.FAIL = exports.SUCCESS = exports.REQUEST = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REQUEST = 'REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAIL = 'FAIL';
exports.FAIL = FAIL;
var ALL_ACTION_TYPES = [REQUEST, SUCCESS, FAIL];
exports.ALL_ACTION_TYPES = ALL_ACTION_TYPES;

/**
 * Returns valid redux action.
 *
 * @deprecated use redux-actions.
 *
 * @template P
 * @param {string} type
 * @param {P} payload
 * @returns {ReduxAction<P>}
 */
var action = function action(type, payload) {
  return {
    type: type,
    payload: payload
  };
};
/**
 * Create actions types. Contained REQUEST, SUCCESS, FAIL action types.
 *
 * @deprecated use redux-actions.
 *
 * @param {string} base
 * @returns {RequestActionMap}
 */


exports.action = action;

var createRequestTypes = function createRequestTypes(base) {
  return ALL_ACTION_TYPES.reduce(function (acc, type) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, type, "".concat(base, "_").concat(type)));
  }, {});
};

exports.createRequestTypes = createRequestTypes;